<template>
  <div
    class="work-bench-workpackage-colorpicker font-weight-light"
    >
    <template v-if="!this.isFavoriteMode">
      <div :class="`${color}--text`">{{color}}</div>
    </template>
    <div class="work-bench-workpackage-colorpicker-items">
      <div
        v-for="brightness in regularOrFavoriteColor"
        :key="brightness.value"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
              :class="`work-bench-workpackage-colorpicker-item ${color} ${brightness.value}`"
              :style="`
              ${selected_color === `${color} ${brightness.value}`?'background-color: #302244; border-radius: 3px; border: 2px solid transparent; border-image: linear-gradient(to bottom right, #b827fc 0%, #2c90fc 25%, #b8fd33 50%, #fec837 75%, #fd1892 100%); border-image-slice: 1; !important':''}
              ${!selected_color.includes('lighten') && !selected_color.includes('darken')
              && selected_color === color && brightness.value === 'lighten-1'?
              'border: solid 1px white !important;':''}
              `"
              @click="$emit('clickColor', {color: `${color} ${brightness.value}`, text_color: brightness.text_color})"
            >
              <div :style="`color: ${brightness.text_color};`">
                {{selected_color === `${color} ${brightness.value}`?`x`:''}}
                <!-- {{selected_color === `${color} ${brightness.value}`?`x`:`${brightness.text}`}} -->
              </div>
            </div>
          </template>
          <span>{{color + ' ' + brightness.value}}</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['color',
            'selected_color',
            // `favorite_mode`, is accessed via `isFavoriteMode`
            `favorite_color`
          ],
    data: () => ({
    }),
    computed: {
      regularOrFavoriteColor(){
        if (this.isFavoriteMode) {
          let favorite_color = this.favorite_color.split(' ')
          let favorite_brightness = favorite_color[1]
          let favorite_text_color = ''
          if (favorite_brightness === 'darken-4' | favorite_brightness === 'darken-2') {
            favorite_text_color = 'white'
          }else{
            favorite_text_color = 'black'
          }
           //wofür ist hier der text teil??? leiche???
          return [{text: '0', value: favorite_brightness, text_color: favorite_text_color}]
        }else{
          return [
            {text: '-2', value: 'darken-4', text_color: 'white'},
            {text: '-1', value: 'darken-2', text_color: 'white'},
            {text: '0', value: 'lighten-1', text_color: 'black'},
            {text: '1', value: 'lighten-2', text_color: 'black'},
            {text: '2', value: 'lighten-3', text_color: 'black'},
            ]
        }
      },
      isFavoriteMode() {
        let a = this.$attrs;
        if (a.favorite_mode !== undefined) {
          if (a.favorite_mode || a.favorite_mode === '') { return true; }
        }
        return false;
      },
    }
  }

</script>
<style>
  .work-bench-workpackage-colorpicker {

  }
  .work-bench-workpackage-colorpicker-item {
    display: flex;
    height: 20px;
    width: 30px;
    border-radius: 3px;
    justify-content: center;
    align-items: center;
    margin-right: 6px;
    cursor: pointer;
    font-size: 14px;
    box-shadow: 0.5px 0.5px #ffffffbf;
  }
  .work-bench-workpackage-colorpicker-items {
    display: flex;
  }
</style>
